import React from 'react';
import { UserPlus } from 'lucide-react';
import EnseignantExterneCard from './EnseignantExterneCard';
import EmptyState from '../../common/EmptyState';

const EnseignantExterneList = ({ 
  enseignants, 
  loading, 
  searchTerm, 
  onEdit, 
  onDelete, 
  onViewDetails, 
  onAddNew 
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-gray-200 h-64 rounded-lg animate-pulse"></div>
        ))}
      </div>
    );
  }

  if (enseignants.length === 0) {
    return (
      <EmptyState
        icon={UserPlus}
        title="Aucun enseignant externe"
        description={
          searchTerm 
            ? "Aucun enseignant externe trouvé pour cette recherche." 
            : "Commencez par ajouter un nouvel enseignant externe."
        }
        actionLabel="Nouvel Enseignant"
        onAction={onAddNew}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {enseignants.map((enseignant) => (
        <EnseignantExterneCard
          key={enseignant.id}
          enseignant={enseignant}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
};

export default EnseignantExterneList; 